import React from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Controller } from "react-hook-form";
import { Password } from "primereact/password";
import { authActions } from "../../../redux/actions/auth.action";
import { getUserPayload } from "../../../system";
import { translationConstants } from "../../../constants";

const ChangePassword = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const {
    control,
    getValues,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    const storedUserData = getUserPayload();

    const dataToSend = {
      userEmail: storedUserData?.user?.email,
      oldPassword: data.currentPassword,
      newPassword: data.newPassword,
      confirmPassword: data.confirmNewPassword,
    };
    dispatch(authActions.changePassword(dataToSend, props.setShow));
  };

  return (
    <Form noValidate onSubmit={handleSubmit(onSubmit)}>
      <span className="loginPara">
        {t(translationConstants.CHANGE_PASSWORD)}
      </span>
      <span className="welcomePara">
        {t(translationConstants.CHANGE_PASSWORD_DESCRIPTION)}
      </span>
      <Form.Group className="form-group">
        <Form.Label className="Form-labels">
          {t(translationConstants.CURRENT_PASSWORD)}:
        </Form.Label>
        <Controller
          name="currentPassword"
          className="LoginPasswordEye"
          control={control}
          rules={{
            required: t(translationConstants.passwordRequired),
            // minLength: {
            //   value: 8,
            //   message: t(translationConstants.passwordMinLength),
            // },
          }}
          render={({ field }) => (
            <Password {...field} toggleMask feedback={false} />
          )}
        />
        {errors.currentPassword && (
          <p className="errorText">{errors.currentPassword.message}</p>
        )}
      </Form.Group>
      <Form.Group className="form-group">
        <Form.Label className="Form-labels">
          {t(translationConstants.NEW_PASSWORD)}:
        </Form.Label>
        <Controller
          name="newPassword"
          className="LoginPasswordEye"
          control={control}
          rules={{
            required: t(translationConstants.passwordRequired),
            pattern: {
              value:
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
              message: t(translationConstants.passwordRequirements),
            },
          }}
          render={({ field }) => (
            <Password {...field} toggleMask feedback={false} />
          )}
        />
        {errors.newPassword && (
          <p className="errorText">{errors.newPassword.message}</p>
        )}
      </Form.Group>
      <Form.Group className="form-group">
        <Form.Label className="Form-labels">
          {t(translationConstants.CONFIRM_NEW_PASSWORD)}:
        </Form.Label>
        <Controller
          name="confirmNewPassword"
          className="LoginPasswordEye"
          control={control}
          rules={{
            required: t(translationConstants.passwordRequired),
            // minLength: {
            //   value: 8,
            //   message: t(translationConstants.passwordMinLength),
            // },
            validate: (value) =>
              value === getValues("newPassword") ||
              t(translationConstants.passwordsDoNotMatch),
          }}
          render={({ field }) => (
            <Password {...field} toggleMask feedback={false} />
          )}
        />
        {errors.confirmNewPassword && (
          <p className="errorText">{errors.confirmNewPassword.message}</p>
        )}
      </Form.Group>
      <Button className="Login-button w-50" type="submit">
        {t(translationConstants.confirm)}
      </Button>
    </Form>
  );
};

export default ChangePassword;
